module.exports = __webpack_public_path__ + "img/wide.1d767944.jpg";